/* Keep the existing autoplay/visibility/reduced-motion controller.
   Replace its visible overlay with accessible tap/keyboard control. */
(() => {
  'use strict';
  if (window.elxClassicVideoMobile) {
    window.elxClassicVideoMobile.init(document);
    return;
  }
  const bound = new Map();
  function init(scope = document) {
    const controller = window.elxExecutiveStudio;
    if (!controller) return; // Native controls remain available if it fails to load.
    controller.init(scope);
    scope.querySelectorAll('.exs [data-exs-player]').forEach(box => {
      if (bound.has(box)) return;
      const video = box.querySelector('video');
      const toggle = box.querySelector('[data-exs-toggle]');
      if (!video || !toggle) return;
      const cleanup = [];
      const on = (node, event, handler, options) => {
        node.addEventListener(event, handler, options);
        cleanup.push(() => node.removeEventListener(event, handler, options));
      };
      // Retain the existing controller's internal button, but never display it.
      toggle.setAttribute('aria-hidden', 'true');
      toggle.tabIndex = -1;
      video.tabIndex = 0;
      video.setAttribute('role', 'button');
      video.setAttribute('playsinline', '');
      const card = box.closest('.exs-story-inner');
      if (card) card.classList.add('exs-inline-video');
      const sync = () => {
        video.setAttribute('aria-label', video.paused ? 'Play product video' : 'Pause product video');
      };
      let down = null;
      let dragged = false;
      on(video, 'pointerdown', event => {
        down = { x: event.clientX, y: event.clientY };
        dragged = false;
      }, { passive: true });
      on(video, 'pointermove', event => {
        if (down && Math.hypot(event.clientX - down.x, event.clientY - down.y) > 8) dragged = true;
      }, { passive: true });
      on(video, 'pointercancel', () => { dragged = true; down = null; });
      on(video, 'click', event => {
        const moved = down && Math.hypot(event.clientX - down.x, event.clientY - down.y) > 8;
        down = null;
        if (dragged || moved || video.controls) return;
        toggle.click();
        sync();
      });
      on(video, 'keydown', event => {
        if (video.controls || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        if (!event.repeat) { toggle.click(); sync(); }
      });
      on(video, 'play', sync);
      on(video, 'pause', sync);
      on(video, 'error', () => {
        video.removeAttribute('role');
        video.setAttribute('aria-label', 'Product video');
      });
      sync();
      bound.set(box, () => {
        cleanup.forEach(remove => remove());
        if (card) card.classList.remove('exs-inline-video');
        bound.delete(box);
      });
    });
  }
  window.elxClassicVideoMobile = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else init(document);
  window.addEventListener('load', () => init(document), { once: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    [...bound].forEach(([box, dispose]) => {
      if (event.target.contains(box)) dispose();
    });
  });
})();
